module.exports = __webpack_public_path__ + "static/landingpage_icons_v2-04-70b3f7a899faa482efbfcd61a7af710d.png";